// extracted by mini-css-extract-plugin
export default {"wrap":"loading-journey_wrap__n8zkb","page":"loading-journey_page__DFJKE","pane":"loading-journey_pane__8gAU3"};